import addMarkdown from "global/markdown/simplemde-getresponse.src.js";
import initSelect2 from 'global/select2v1';

$(document).ready(function($) {

    loadData();
    addMarkdown();
    [].forEach.call(document.querySelectorAll('.multiselect'), initSelect2);
    var filesClone;

    var free = $('.price-fields').find('.free .form-group');
    var paid = $('.price-fields').find('.paid .form-group');
    var wrappError = $('<div>').addClass('wrapp-error')


    wrappError.appendTo(free);
    wrappError.prependTo(paid);

    // captcha validator options
    var captchaOptions = {};
    if($('#captcha_container').length) {
        var captchaMessage = $('#captcha_container').attr('data-fv-message');
        captchaOptions = {
            addOns: {
                reCaptcha2: {
                    element: 'captcha_container',
                    siteKey: '6LcyWRsUAAAAALEi23AyVvcTogjVqGKCAkqZmCbq',
                    message: captchaMessage
                }
            }
        };
    }
    // $('#join_form').formValidation(
    //     captchaOptions
    //     );
    var objectValidateOptions = {};
    Object.assign(objectValidateOptions, {err: {
        container: function($field, validator) {
            if($($field[0]).attr('id') == 'offer_paid') {
                // console.log($field[0])
                return $field.next('.wrapp-error');
            }
        }
    }},
    captchaOptions);
    // init form validator
    $('#join_form').formValidation(objectValidateOptions);


    // images dimension validator options
    window.URL = window.URL || window.webkitURL;
    var imagesOptions = {
        validators: {
            promise: {
                promise: function(value, validator, $field) {
                    var dfd = new $.Deferred(),
                        files = $field[0].files || [];

                    if (files.length == 0) {
                        dfd.resolve({ valid: true });
                        return dfd.promise(); // quit
                    }

                    var count = 0;
                    for(var i = 0; i < files.length; i++) {
                        var img = new Image(),
                            file = files[i];

                        img.onload = function() {
                            var w  = this.naturalWidth || this.width,
                                h = this.naturalHeight || this.height;

                            window.URL.revokeObjectURL(img.src);
                            if(
                                ($field.attr('name') == 'form[foto][]' &&
                                    (w < 640 || h < 480)
                                ) ||
                                ($field.attr('name') == 'form[logo]' &&
                                    (w < 760 && h < 280))
                            ) {
                                dfd.reject({
                                    message: $field.attr('data-fv-promise-message')
                                });
                                return dfd.promise(); // quit
                            }

                            count += 1;
                            if(count == files.length) {
                                //console.log('done');
                                dfd.resolve({ valid: true });
                            }
                        };
                        img.onerror = function() {
                            dfd.reject({
                                message: $field.attr('data-fv-message')
                            });
                            return dfd.promise(); // quit
                        };
                        img.src = window.URL.createObjectURL(file);
                    }
                    return dfd.promise();
                }
            }
        }
    };

    // add dimension validation for file inputs
    $('[type="file"]').each(function() {
        var fileElement = $(this);
        $('#join_form').formValidation('addField', fileElement, imagesOptions);
    });

    // list uploaded file names
    $('#join_form').delegate('[type="file"]','change',function(e) {
        var fileElement = $(e.target);
        //console.log('changed files: ', fileElement[0].files.length);
        if(fileElement[0].files.length == 0) {
            //console.log('no files, put clone, remove original', filesClone);
            filesClone.insertBefore(fileElement);
            $('#join_form').formValidation('removeField', fileElement); // remove from validation
            fileElement.remove();
            $('#join_form').formValidation('addField', filesClone, imagesOptions); // add clone to validation
        } else {
            var imagesData = fileElement[0].files || [];
            fileElement.parent().find('.files').empty();
            //console.log('new files: ', fileElement[0].files.length)
            for(var i = 0; i < imagesData.length; i++) {
                var textNode = document.createTextNode(imagesData[i].name);
                fileElement.parent().find('.files').append(textNode);
                fileElement.parent().find('.files').append('<br>');
            }
        }
    });

    // make clone with files
    $('#join_form').delegate('[type="file"]','click drop',function(e) {
        var fileElement = $(e.target);
        //console.log('clicked/draged: ', fileElement[0].files.length);
        if (fileElement[0].files.length != 0) {
            //console.log('not empty, make clone');
            filesClone = $(fileElement).clone();
            //console.log('cloned: ', clone);
        }
    });

    // clone price input
    var form_group = $('<div>').addClass('form-group');

    form_group.appendTo('#join_form .price-wrapper .paid');
    $('#join_form .free label').clone().attr('for', 'offer_start').appendTo(form_group);
    $('#join_form #offer_paid').clone().attr('id', 'offer_start').attr('name', '').attr('disabled', true).val('').appendTo(form_group);

    // switch price tab
    if($('#marketplace_price_0').is(':checked')) $('#join_form .price-wrapper').hide();
    if($('#marketplace_price_1').is(':checked')) {
        $('#join_form .price-wrapper').show();
    }

    $('#join_form [name="marketplace[price]"]').change(function() {
        if($(this).val() == 'paid') {
            $('#join_form .price-wrapper').show();
            $('[name="marketplace[paidPrice]"]').prop('disabled', false);
            $('[name="marketplace[price_value]"]').prop('disabled', false);
        } else {
            $('#join_form .price-wrapper').hide();
            $('[name="marketplace[paidPrice]"]').prop('disabled', true);
            $('[name="marketplace[price_value]"]').prop('disabled', true);
        }
    });
    if($('#form_paidPrice_1').is(':checked')) {
        var ffg = $('.price-wrapper .free .form-group');
        var pfg = $('.price-wrapper .paid .form-group');
        $('.price-wrapper .free').append(pfg);
        $('.price-wrapper .paid').append(ffg);
    }
    $('#join_form [name="marketplace[paidPrice]"]').change(function() {
        var ffg = $('.price-wrapper .free .form-group');
        var pfg = $('.price-wrapper .paid .form-group');
        $('.price-wrapper .free').append(pfg);
        $('.price-wrapper .paid').append(ffg);

    });

    // keep form data in localStorage
    $('#join_form').on('submit', function(e) {
        var formData = $(this).serializeArray();
        for(var i = 0; i < formData.length; i++) {
            if(formData[i].value == '') { // remove empty
                formData.splice(i,1); i -= 1;
            } else {
                if(formData[i].name == '_token') { // remove token
                    formData.splice(i,1); i -= 1;
                } else if(formData[i].name == 'g-recaptcha-response') { // remove captcha
                    formData.splice(i,1); i -= 1;
                }
            }
        }
        localStorage.setItem('joinForm', JSON.stringify(formData));
    });

    // if back from thank you page to send next offer
    var nextOffer = (window.location.href).split('?')[1];
    if (nextOffer != undefined) {
        nextOffer = nextOffer.split('#')[0];
        if(nextOffer == 'next=1') {
            $('.scroll-btn').click();
        }
    }

    // load back saved form data
    function loadData() {
        if(localStorage.getItem('joinForm') !== null) {
            var storedJoinForm = JSON.parse(localStorage.getItem('joinForm')),
                solution_types = [];
            for(var i = 0; i < storedJoinForm.length; i++) {
                if($('[name="' + storedJoinForm[i].name + '"]').is(':radio')) { // price checkbox
                    $('[name="' + storedJoinForm[i].name + '"][value="' + storedJoinForm[i].value + '"]').prop('checked', true);
                } else if($('[name="' + storedJoinForm[i].name + '"]').is(':checkbox')) { // certified checkbox
                    $('[name="' + storedJoinForm[i].name + '"]').prop('checked', storedJoinForm[i].value);
                } else if(storedJoinForm[i].name == 'form[solution_types][]') { // categories multiselect
                   solution_types.push(storedJoinForm[i].value);
                } else { // all other
                    if (storedJoinForm[i].value != '') {
                        $('[name="' + storedJoinForm[i].name + '"]').val(storedJoinForm[i].value);
                    }
                }
            }
            $('[name="marketplace[solution_types][]"]').val(solution_types);
        }
    }
});


